module.exports = __webpack_public_path__ + "img/roll-509.abc63cbb.png";